import { parseTilesetCellKey } from '../shared/Tilesets'
import { parseTilesetAutotileKey, pickQuarterShape } from '../shared/TilesetAutotiles'

const TILE_SIZE = 16

export class TilesetAtlasProvider {
  constructor(client) {
    this.client = client
    this._images = new Map() // url -> Promise<HTMLImageElement>
  }

  getSource(key) {
    return { widthPx: TILE_SIZE, heightPx: TILE_SIZE }
  }

  renderInto(key, fn) {
    if (key.startsWith('ts-at:')) return this._renderAutotile(key, fn)
    return this._renderCells(key, fn)
  }

  _renderCells(key, fn) {
    const parsed = parseTilesetCellKey(key)
    const url = parsed.tilesetId
    const T = TILE_SIZE
    return this._loadImage(url).then(img => {
      const { cells } = parsed
      const frameCount = cells.length
      const canvas = document.createElement('canvas')
      canvas.width = T * frameCount
      canvas.height = T
      const ctx = canvas.getContext('2d')
      ctx.imageSmoothingEnabled = false
      for (let f = 0; f < frameCount; f++) {
        const [cx, cy] = cells[f]
        ctx.drawImage(img, cx * T, cy * T, T, T, f * T, 0, T, T)
      }
      fn({ canvas, widthPx: T, heightPx: T, frameCount })
    })
  }

  _renderAutotile(key, fn) {
    const parsed = parseTilesetAutotileKey(key)
    if (!parsed) return Promise.resolve()
    const url = parsed.tilesetId
    const T = TILE_SIZE
    const H = T / 2
    const allBaseCells = [[parsed.x, parsed.y], ...(parsed.frames || [])]
    const frameCount = allBaseCells.length

    return this._loadImage(url).then(img => {
      const canvas = document.createElement('canvas')
      canvas.width = T * frameCount
      canvas.height = T
      const ctx = canvas.getContext('2d')
      ctx.imageSmoothingEnabled = false

      const QUARTERS = [
        { kind: 'tl', dx: 0, dy: 0 },
        { kind: 'tr', dx: H, dy: 0 },
        { kind: 'bl', dx: 0, dy: H },
        { kind: 'br', dx: H, dy: H },
      ]

      for (let frame = 0; frame < frameCount; frame++) {
        const [baseCx, baseCy] = allBaseCells[frame]
        const dstOffsetX = frame * T

        for (const { kind, dx, dy } of QUARTERS) {
          const { row, col } = pickQuarterShape(kind, parsed.bits)
          ctx.drawImage(img, baseCx * T + col * H, baseCy * T + row * H, H, H, dstOffsetX + dx, dy, H, H)
        }
      }

      fn({ canvas, widthPx: T, heightPx: T, frameCount })
    })
  }

  _loadImage(url) {
    if (!this._images.has(url)) {
      this._images.set(url, this.client.loader.load(url))
    }
    return this._images.get(url)
  }
}
